export default async function ({ app, store, redirect }) {
    const isLogged = store.state.admin.auth.isLogged
    if (!isLogged) {
        return redirect('/admin/auth/login')
    }
}
